<p>
  translator-orientation works!
</p>
